import React from 'react';
import maharajImg from '../assets/maharajImg.png';

const Maharaj = () => {
  return (
    <div className="w-full h-screen overflow-hidden relative flex flex-col">
      {/* White Section (Title) */}
      <div className="w-full h-1/5 bg-white flex justify-center items-center p-4">
        <h1 className="text-lg sm:text-xl md:text-2xl lg:text-4xl font-bold text-[#B50301] text-center px-4 md:mr-72 leading-snug sm:leading-normal">
          डॉ. भीमराव अंबेडकर के जीवन में महाराजा<br />
          सयाजीराव गायकवाड़ III की भूमिका
        </h1>
      </div>

      {/* Image Positioned to overlap white and red sections */}
      <div className="absolute right-2 sm:right-4 md:right-8 lg:right-12 top-[14vh] sm:top-[13vh] lg:top-[10vh] w-24 sm:w-32 md:w-48 lg:w-64 xl:w-80 z-10 opacity-50 lg:opacity-100 md:opacity-100">
        <img
          src={maharajImg}
          alt="Maharaja Sayajirao Gaekwad III"
          className="grayscale w-full h-auto"
        />
      </div>

      {/* Red Section (Content) */}
      <div className="w-full h-4/5 bg-[#B50301] text-white flex justify-center items-start overflow-y-auto">
        <div className="max-w-5xl mx-4 sm:mx-6 md:mr-96 space-y-4 py-6 sm:py-8 text-justify leading-relaxed">
          <p className="text-xs sm:text-sm md:text-base lg:text-lg lg:mr-6">
            डॉ. भीमराव अंबेडकर के जीवन में महाराजा सयाजीराव गायकवाड़ III की महत्वपूर्ण भूमिका थी, जिन्होंने अंबेडकर को उच्च शिक्षा प्राप्त करने में मदद की। 1950 में, अंबेडकर ने बड़ौदा के तत्कालीन शासक प्रतापसिंह राव गायकवाड़ को पत्र लिखा, जिसमें उन्होंने सयाजीराव के प्रति अपनी गहरी कृतज्ञता व्यक्त की और कहा कि सयाजीराव उनके "भाग्य के निर्माता" थे।
          </p>
          <p className="text-xs sm:text-sm md:text-base lg:text-lg lg:mr-6">
            सयाजीराव ने अंबेडकर को बॉम्बे के एलफिन्स्टन कॉलेज में पढ़ने के लिए 25 रुपये की छात्रवृत्ति दी, जो बाद में उन्हें न्यूयॉर्क की कोलंबिया यूनिवर्सिटी में पढ़ाई के लिए £11.5 मासिक अनुदान में बदल गया। यहां से अंबेडकर ने अर्थशास्त्र में मास्टर्स की डिग्री हासिल की और लंदन स्कूल ऑफ इकोनॉमिक्स में भी अध्ययन किया। सयाजीराव ने अंबेडकर जैसे अछूत छात्र को आर्थिक सहायता देकर यह संदेश दिया कि शिक्षा सभी के लिए है।
          </p>
          <p className="text-xs sm:text-sm md:text-base lg:text-lg lg:mr-6">
            सयाजीराव ने समाज सुधार के क्षेत्र में कई प्रयास किए, जैसे बालिका शिक्षा, अछूतों के लिए विशेष स्कूल खोलना, और विधवा पुनर्विवाह को बढ़ावा देना। इन सभी विचारों का प्रभाव अंबेडकर द्वारा तैयार किए गए भारतीय संविधान में भी देखने को मिलता है। सयाजीराव की सोच और उनके कार्यों का असर अंबेडकर के विचारों पर स्पष्ट रूप से पड़ा, जो उन्होंने अपनी संविधान सभा के काम में दर्शाया।
          </p>
          <p className="text-xs sm:text-sm md:text-base lg:text-lg lg:mr-6">
            हालांकि, अंबेडकर को बड़ौदा में अपने पहले और दूसरे कार्यकाल के दौरान भेदभाव का सामना करना पड़ा। उन्हें रहने के लिए उचित स्थान नहीं मिला, क्लब में प्रवेश से रोका गया और काम की जगह पर भी जातिगत भेदभाव झेलना पड़ा। सयाजीराव ने इस स्थिति को समझते हुए अंबेडकर को धैर्य रखने की सलाह दी, क्योंकि उस समय सामाजिक सुधार की राह में कई सीमाएँ थीं।
          </p>
          <p className="text-xs sm:text-sm md:text-base lg:text-lg lg:mr-6">
            अंबेडकर ने बड़ौदा में अपने कठिन अनुभवों के बावजूद सयाजीराव के प्रति अपना सम्मान बनाए रखा। सयाजीराव का प्रगतिशील दृष्टिकोण और अंबेडकर को दी गई शिक्षा ही थी जिसने अंबेडकर को जीवन में एक उच्च स्थान तक पहुँचाया।
          </p>
        </div>
      </div>
    </div>
  );
};

export default Maharaj;
